import { getKnowledgeProcessingErrorI18nKey } from "@frontend-shared/utils";
import { AlertCircle } from "lucide-react";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import type { IKnowledgeProcessingErrorTextProps } from "./types";

// NOTE: NSAI-7817 — the translated reason a file failed to index ("too much
// text — split it", "took too long", ...). Before it, a failed file showed a
// bare "Failed" in the folder panel and the server's English log text as a
// tooltip on the Knowledge page.
const KnowledgeProcessingErrorTextInner: React.FC<
  IKnowledgeProcessingErrorTextProps
> = ({ code, rawError, testId }) => {
  // NOTE: The instance's `t` — the keys carry their namespace ("knowledge:…"),
  // which the hook's namespace-bound `t` does not accept.
  const { i18n } = useTranslation("knowledge");
  const key = getKnowledgeProcessingErrorI18nKey({ code });
  const text = key ? i18n.t(key) : rawError;

  if (!text) {
    return null;
  }

  return (
    <p
      className="mt-1 flex items-start gap-1 text-xs text-destructive break-words"
      data-testid={testId}
    >
      <AlertCircle className="mt-px h-3.5 w-3.5 shrink-0" />
      <span className="break-words">{text}</span>
    </p>
  );
};

export const KnowledgeProcessingErrorText = memo(
  KnowledgeProcessingErrorTextInner,
);
